module.exports = __webpack_public_path__ + "static/media/cristina.59ab0fa1.jpg";